module.exports = __webpack_public_path__ + "static/media/elife-general-go-to-park.72e68e08.png";